module.exports = __webpack_public_path__ + "img/persona.71b5a66.jpg";